import { igPostsQueryNew_posts_edges_node } from 'graphql/insights/queries/__generated__/igPostsQueryNew';
import { IG_MEDIA_PRODUCT_TO_TYPE_MAP } from 'app/modules/insights/constants/postType';

export const getPostTypeByMediaProduct = (
  post: Pick<igPostsQueryNew_posts_edges_node, 'type' | 'mediaProductType'>,
) => {
  return IG_MEDIA_PRODUCT_TO_TYPE_MAP[post.mediaProductType!] || post.type;
};
